// Vue router setup
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import requireAuth from "@/helpers/requireAuth";

// Components
import Hub from "@/containers/Hub";
import NotFound from "@/containers/NotFound";

import Login from "@/containers/Login";
import AuthCallback from "@/containers/AuthCallback";

import Profile from "@/containers/Profile";

import DashboardLayout from "@/components/Layout/DashboardLayout";

import AdminPanel from "@/containers/AdminPanel";
import FederationPanel from "@/containers/FederationPanel";
import DisciplinePanel from "@/containers/DisciplinePanel";
import CoachPanel from "@/containers/CoachPanel";
import TeamPanel from "@/containers/TeamPanel";

import Exercises from "@/containers/Exercises";
import Exercise from "@/containers/Exercise";
import ExercisePPGView from "@/containers/ExercisePpgView";
import ExerciseView from "@/containers/ExerciseView";

import GCE from "@/containers/Cycle";
import GCEList from "@/containers/Cycles";
import GCEViewer from "@/containers/CycleView";
import Session from "@/containers/Session";

import MyMedias from "@/containers/MyMedias";

const routes = [
  {
    name: "Dashboard",
    path: "/",
    component: DashboardLayout,
    redirect: "/hub",
    children: [
      {
        name: "exercises",
        path: "/exercises",
        meta: {
          section: 'ENE',
        },
        component: Exercises,
        beforeEnter: requireAuth,
      },
      {
        name: "login",
        path: "/login",
        component: Login,
      },
      {
        path: "/callback",
        component: AuthCallback,
      },
      {
        name: "profile",
        path: "/profile",
        component: Profile,
        beforeEnter: requireAuth,
      },
      {
        name: "exerciseView",
        path: "/exercise/:id/view",
        meta: {
          section: 'ENE',
        },
        component: ExerciseView,
        beforeEnter: requireAuth,
        props: route => ({ id: route.params.id })
      },
      {
        name: "exercise",
        path: "/exercise/:id?",
        meta: {
          section: 'ENE',
        },
        component: Exercise,
        beforeEnter: requireAuth,
        props: route => ({ id: route.params.id })
      },
      {
        name: "exercisePPG",
        path: "/exercisePPG/:id?",
        meta: {
          section: 'ENE',
        },
        component: ExercisePPGView,
        beforeEnter: requireAuth,
        props: route => ({ id: route.params.id })
      },
      {
        name: "adminpanel",
        path: "/adminpanel/:tab",
        component: AdminPanel,
        beforeEnter: requireAuth,
        props: (route) => ({ tab: route.params.tab })
      },
      {
        name: "GCE",
        path: "/cycle/:id?",
        component: GCE,
        meta: {
          section: 'GCE',
        },
        beforeEnter: requireAuth,
        props: route => ({ id: route.params.id })
      },
      {
        name: "GCEViewer",
        path: "/cycle/:id/view",
        meta: {
          section: 'GCE',
        },
        component: GCEViewer,
        props: route => ({ id: route.params.id })
      },
      {
        name: "GCEList",
        path: "/cycles",
        meta: {
          section: 'GCE',
        },
        component: GCEList,
        beforeEnter: requireAuth,
      },
      {
        name: "session",
        path: "/cycle/:id/session/:sessionId",
        meta: {
          section: 'GCE',
        },
        component: Session,
        props: route => ({
          id: route.params.id,
          sessionId: route.params.sessionId,
        })
      },
      {
        name: "Hub",
        path: "/hub",
        component: Hub,
        beforeEnter: requireAuth,
      },
      {
        name: "FederationPanel",
        path: "/federationpanel/:federationId/:tab?",
        component: FederationPanel,
        beforeEnter: requireAuth,
        props: (route) => ({
          federationId: route.params.federationId,
          tab: route.params.tab
        })
      },
      {
        name: "DisciplinePanel",
        path: "/federation/:federationId/discipline/:disciplineId/:tab?",
        component: DisciplinePanel,
        beforeEnter: requireAuth,
        props: (route) => ({
          federationId: route.params.federationId,
          disciplineId: route.params.disciplineId,
          tab: route.params.tab,
        })
      },
      {
        name: "CoachPanel",
        path: "/federation/:federationId/discipline/:disciplineId/coach/:coachId/:tab?",
        component: CoachPanel,
        beforeEnter: requireAuth,
        props: (route) => ({
          federationId: route.params.federationId,
          disciplineId: route.params.disciplineId,
          coachId: route.params.coachId,
          tab: route.params.tab,
        })
      },
      {
        name: "TeamPanel",
        path: "/federation/:federationId/discipline/:disciplineId/coach/:coachId/team/:teamId/:tab?",
        component: TeamPanel,
        beforeEnter: requireAuth,
        props: (route) => ({
          federationId: route.params.federationId,
          disciplineId: route.params.disciplineId,
          coachId: route.params.coachId,
          teamId: route.params.teamId,
          tab: route.params.tab,
        })
      },
      {
        name: "Médias",
        path: "/medias",
        component: MyMedias,
        beforeEnter: requireAuth,
      },
      // If there is nothing in the route we wanna redirect to hub
      {
        path: "",
        component: Hub,
        beforeEnter: requireAuth,
      },   
      {
        name: "NotFound",
        path: "/notfound",
        component: NotFound,
        beforeEnter: requireAuth,
      },
      // Finally the default route when none of the above matches
      {
        path: "/:pathMatch(.*)*",
        component: NotFound,
        beforeEnter: requireAuth,
      }
    ],
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;